import React, { Fragment } from 'react';

import GlobalColumnFunctions from '../../../../../../../utils/globalColumnFunctions';
import BaseColumnDefinitions from '../baseColumnDefinitions';

// Shortening the function name
const CreateHeaderCell = BaseColumnDefinitions.CreateHeaderCell;

//Column Definitions
const FRANCHISE_COL = {
    accessor: 'teamName',
    Cell: ({ original, value }) => {
        if (original.isActive === 1 || original.activeStreak) {
            return (
                <Fragment>
                    {value}
                    {<span title="Streak is Active" className="active-indicator-icon" />}
                </Fragment>
            );
        }
        return value;
    },
    getProps: GlobalColumnFunctions.getProps,
    minWidth: window.innerWidth > 414 ? 150 : 130,
    headerClassName: 'left',
    className: 'left',
    Header: CreateHeaderCell('Franchise', 'Franchise', { textAlign: 'left' }),
};

const FRANCHISE_COL_NO_ACTIVE_INDICATOR = {
    accessor: 'teamName',
    Cell: ({ original, value }) => value,
    getProps: GlobalColumnFunctions.getProps,
    minWidth: window.innerWidth > 414 ? 150 : 130,
    headerClassName: 'left',
    className: 'left',
    Header: CreateHeaderCell('Franchise', 'Franchise', { textAlign: 'left' }),
};

const STREAK_COL = {
    accessor: 'streakLength',
    getProps: GlobalColumnFunctions.getProps,
    Header: CreateHeaderCell('Streak'),
};

//Column Groupings
const POINT_STREAK_COLS = [
    BaseColumnDefinitions.INDEX_COL,
    FRANCHISE_COL,
    BaseColumnDefinitions.SEASON_COL,
    STREAK_COL,
    BaseColumnDefinitions.WINS_COL,
    BaseColumnDefinitions.LOSSES_COL,
    BaseColumnDefinitions.TIES_COL,
    BaseColumnDefinitions.OVERTIME_LOSSES_COL,
    BaseColumnDefinitions.START_DATE_COL,
    BaseColumnDefinitions.END_DATE_COL,
];

const FRANCHISE_POINT_STREAK_COLS = [
    BaseColumnDefinitions.INDEX_COL,
    FRANCHISE_COL,
    { ...BaseColumnDefinitions.OPPONENT_COL, Header: CreateHeaderCell('Opponent', 'Opponent', { textAlign: 'left' }) },
    STREAK_COL,
    BaseColumnDefinitions.WINS_COL,
    BaseColumnDefinitions.LOSSES_COL,
    BaseColumnDefinitions.TIES_COL,
    BaseColumnDefinitions.OVERTIME_LOSSES_COL,
    BaseColumnDefinitions.START_DATE_COL,
    BaseColumnDefinitions.END_DATE_COL,
];

const FRANCHISE_POINT_STREAK_COLS_ACTIVE_STREAKS = [
    BaseColumnDefinitions.INDEX_COL,
    FRANCHISE_COL_NO_ACTIVE_INDICATOR,
    { ...BaseColumnDefinitions.OPPONENT_COL, Header: CreateHeaderCell('Opponent', 'Opponent', { textAlign: 'left' }) },
    STREAK_COL,
    BaseColumnDefinitions.WINS_COL,
    BaseColumnDefinitions.LOSSES_COL,
    BaseColumnDefinitions.TIES_COL,
    BaseColumnDefinitions.OVERTIME_LOSSES_COL,
    BaseColumnDefinitions.START_DATE_COL,
    BaseColumnDefinitions.END_DATE_COL,
];

export const teamPointStreakColumnDefinitions = {
    'longest-point-streak-one-season': POINT_STREAK_COLS,
    'longest-point-streak-season-start': POINT_STREAK_COLS,
    'longest-home-point-streaks-season': POINT_STREAK_COLS,
    'longest-home-point-streaks-from-start-of-season': POINT_STREAK_COLS,
    'longest-road-point-streaks-season': POINT_STREAK_COLS,
    'longest-road-point-streaks-from-start-of-season': POINT_STREAK_COLS,
    'longest-point-streaks-vs-franchise-nhl-history': FRANCHISE_POINT_STREAK_COLS,
    'longest-point-streaks-vs-franchise-active': FRANCHISE_POINT_STREAK_COLS_ACTIVE_STREAKS,
    'longest-home-point-streaks-vs-franchise-nhl-history': FRANCHISE_POINT_STREAK_COLS,
    'longest-home-point-streaks-vs-franchise-active': FRANCHISE_POINT_STREAK_COLS_ACTIVE_STREAKS,
    'longest-road-point-streaks-vs-franchise-nhl-history': FRANCHISE_POINT_STREAK_COLS,
    'longest-road-point-streaks-vs-franchise-active': FRANCHISE_POINT_STREAK_COLS_ACTIVE_STREAKS,
};
